/**
 * SAAS资源接口
 * sj:2021年3月8日15:36:52
 **/
import { Injectable } from '@angular/core';
import { SwHttpClientService } from 'src/app/librarys/serves/sw-http-client.service';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ResourceManageService {
  //基础平台微服务api
  prefix: string = environment.seekerWebAPI;


  constructor(
    private http: SwHttpClientService
  ) {
  }

  //#region scheduleTask 资源接口


  /**
   * 查询资源列表
   * @param param
   * @returns {Observable<any>}
   */
  queryResourcePageList(param) {
    const url = this.prefix + 'product/queryResourcePageList';
    return this.http.Post(url, param);
  }

  /**
 * 添加资源
 *
 * @param param
 */
  saveResource(param) {
    const url = this.prefix + 'product/saveResource';
    return this.http.Post(url, param);
  }

  /**
* 资源上下架
*
* @param param
*/
updateResourceStatus(param) {
    const url = this.prefix + 'product/updateResourceStatus'+param;
    return this.http.Get(url);
  }
  //#endregion

}
